import BpkButton, { BUTTON_TYPES } from '@skyscanner-internal/backpack-web/bpk-component-button';

import type { ConsentBannerStrings } from '../types';

import STYLES from './BannerActions.module.scss';

export interface BannerActionsProps {
  /**
   * Handler for Accept All button.
   */
  onAcceptAll: () => void;

  /**
   * Handler for Reject All / Accept Essential Only button.
   */
  onRejectAll: () => void;

  /**
   * Handler for Manage Settings click (for logging/tracking).
   */
  onManageSettings: () => void;

  /**
   * Translated UI strings.
   */
  strings: ConsentBannerStrings;
}

/**
 * Banner action buttons component.
 */
export const BannerActions = ({
  onAcceptAll,
  onManageSettings,
  onRejectAll,
  strings,
}: BannerActionsProps) => (
  <div className={STYLES['banner-actions']}>
    <BpkButton
      className={`${STYLES['banner-actions__button']} ${STYLES['banner-actions__button--accept']}`}
      onClick={onAcceptAll}
      data-testid="consentBannerAcceptAll"
      id="acceptCookieButton"
    >
      {strings.declineAllButtonAcceptAll}
    </BpkButton>
    <BpkButton
      type={BUTTON_TYPES.secondary}
      className={`${STYLES['banner-actions__button']} ${STYLES['banner-actions__button--manage']}`}
      href="/privacy-settings"
      onClick={onManageSettings}
      data-testid="consentBannerManageSettings"
    >
      {strings.declineAllButtonManageSettings}
    </BpkButton>
    <BpkButton
      type={BUTTON_TYPES.secondary}
      className={`${STYLES['banner-actions__button']} ${STYLES['banner-actions__button--reject']}`}
      onClick={onRejectAll}
      data-testid="consentBannerRejectAll"
    >
      {strings.declineAllButtonAcceptEssentialOnly}
    </BpkButton>
  </div>
);
